// DMN 1.3 hit policies. Each has a long name, a single-letter abbreviation,
// a group (single-hit vs. multi-hit), and a short description shown in the
// hit-policy picker so the user can tell them apart without consulting the spec.
// Multi-hit policies may also carry an aggregation (SUM/COUNT/MIN/MAX) modelled
// separately on OutputClause.

export const HIT_POLICIES = [
  {
    id: 'UNIQUE', letter: 'U', label: 'Unique', group: 'single',
    description: 'Only one rule can match. Overlapping rules are a modeling error.',
  },
  {
    id: 'ANY', letter: 'A', label: 'Any', group: 'single',
    description: 'Multiple rules can match, but they must all produce the same output.',
  },
  {
    id: 'PRIORITY', letter: 'P', label: 'Priority', group: 'single',
    description: 'When several rules match, pick the one whose output ranks highest in "Output Values".',
  },
  {
    id: 'FIRST', letter: 'F', label: 'First', group: 'single',
    description: 'Return the output of the first rule that matches (order-sensitive).',
  },
  {
    id: 'RULE ORDER', letter: 'R', label: 'Rule Order', group: 'multi',
    description: 'Return all matching outputs, listed in the order rules are declared.',
  },
  {
    id: 'OUTPUT ORDER', letter: 'O', label: 'Output Order', group: 'multi',
    description: 'Return all matching outputs, sorted by rank in "Output Values".',
  },
  {
    id: 'COLLECT', letter: 'C', label: 'Collect', group: 'multi',
    description: 'Return all matching outputs. Optionally aggregate with SUM / COUNT / MIN / MAX.',
  },
];

export const AGGREGATIONS = [
  { id: null,    letter: '',  label: 'List',  description: 'Return the list of matching outputs.' },
  { id: 'SUM',   letter: '+', label: 'Sum',   description: 'Numeric sum of the matching outputs.' },
  { id: 'COUNT', letter: '#', label: 'Count', description: 'Count of matching rules.' },
  { id: 'MIN',   letter: '<', label: 'Min',   description: 'Minimum of the matching outputs.' },
  { id: 'MAX',   letter: '>', label: 'Max',   description: 'Maximum of the matching outputs.' },
];

// DMN 1.3 built-in FEEL types, for the column typeRef picker.
export const DMN_TYPES = [
  'string',
  'number',
  'boolean',
  'integer',
  'double',
  'long',
  'date',
  'time',
  'dateTime',
  'duration',
  'yearMonthDuration',
  'dayTimeDuration',
];

const BY_ID = new Map(HIT_POLICIES.map((h) => [h.id, h]));

export function getHitPolicy(id) {
  return BY_ID.get(id || 'UNIQUE') || BY_ID.get('UNIQUE');
}

export function getHitPolicyLetter(id, aggregation) {
  const hp = getHitPolicy(id);
  if (hp.group === 'multi' && aggregation) {
    const agg = AGGREGATIONS.find((a) => a.id === aggregation);
    if (agg && agg.letter) return hp.letter + agg.letter;
  }
  return hp.letter;
}
